<p-dropdown
  #dropdown
  [filter]="true"
  filterBy="name"
  optionLabel="studyAreaName"
  styleClass="basin-width-100 basin-mt-3"
  [options]="(configurationProfiles$ | async) || []"
  [(ngModel)]="selectedConfigurationProfile"
  (onChange)="selectConfigurationProfile($event)"
  [placeholder]="placeholderText"
>
  <ng-template pTemplate="selectedItem" let-selectedOption>
    <div>
      {{ selectedOption?.name || "" }}
    </div>
  </ng-template>

  <ng-template let-configurationProfile pTemplate="item">
    <basin-list-item
      *ngIf="configurationProfile"
      [primaryLine]="configurationProfile.name"
      [secondaryLine]="configurationProfile.description"
    >
      <div
        rightSection
        *ngIf="configurationProfile.isGlobal"
        class="p-d-flex p-jc-center p-ai-center stantec-green basin-height-100"
      >
        <i class="symbol-public basin-color-blue" pTooltip="Global Configuration Profile"></i>
      </div>
    </basin-list-item>
  </ng-template>
</p-dropdown>

<div class="basin-mb-6">
  <form [formGroup]="form">
    <formly-form
      [form]="form"
      [fields]="fields"
      (modelChange)="onModelChange($event)"
      [model]="model"
    ></formly-form>
  </form>
</div>

<div>
  <form [formGroup]="configurationForm">
    <formly-form
      [form]="configurationForm"
      [fields]="configurationFields"
      [model]="configurationModel"
    ></formly-form>
    <button
      pButton
      (click)="createNewConfigurationProfile()"
      [disabled]="configurationForm.invalid"
      title="Save Configuration Profile"
      label="Save Configuration"
    ></button>
  </form>
</div>
